module.exports = __webpack_public_path__ + "img/chain_industry-solution2.d72328a0.png";